import { render, staticRenderFns } from "./ListadoLotesAlimento.vue?vue&type=template&id=3404489e&scoped=true"
import script from "./ListadoLotesAlimento.vue?vue&type=script&lang=js"
export * from "./ListadoLotesAlimento.vue?vue&type=script&lang=js"
import style0 from "./ListadoLotesAlimento.vue?vue&type=style&index=0&id=3404489e&prod&lang=css"
import style1 from "./ListadoLotesAlimento.vue?vue&type=style&index=1&id=3404489e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3404489e",
  null
  
)

export default component.exports